import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { PiUploadSimple, PiCheck, PiTrash } from "react-icons/pi";
import { RxCross1 } from "react-icons/rx";

const DocumentUpload = ({
    intialTxt,
    uploadingTxt,
    uploadedTxt,
    errorTxt,
    htmlFor,
    onChange,
    className,
    multiple,
}) => {
    const [uploadState, setUploadState] = useState("initial");
    const [errorMessage, setErrorMessage] = useState("");

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setUploadState("uploading");

            // Simulate file upload
            setTimeout(() => {
                // Simulate a successful upload
                setUploadState("uploaded");
                setErrorMessage(""); // Clear any existing error messages

                // Call the external onChange function if provided
                if (onChange) {
                    onChange(event);
                }
            }, 2000);
        } else {
            setUploadState("error");
            setErrorMessage("Failed to upload file.");
        }
    };

    return (
        <div className={className}>
            <div
                className={`upload-document-container ${uploadState === "error"
                    ? "upload-document-container-error"
                    : uploadState === "uploading"
                        ? "upload-document-container-uploading"
                        : uploadState === "uploaded"
                            ? "upload-document-container-uploaded"
                            : ""
                    }`}
            >
                {uploadState === "initial" && (
                    <>
                        <label htmlFor={htmlFor} className="upload-document-lable">
                            <span className="upload-document-icon-blk">
                                <PiUploadSimple
                                    size={18}
                                    className="upload-document-icon text-muted"
                                />
                            </span>
                            <div className="upload-document-lable-text">
                                <h6 className="ud-lable-text exado_body_text">
                                    {intialTxt.udHeading}
                                </h6>
                                <span className="ud-lable-text-span exado_body_text">
                                    {intialTxt.udSubHeading}
                                </span>
                            </div>
                        </label>
                        <input
                            type="file"
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                            id={htmlFor}
                            multiple={multiple}
                        />
                    </>
                )}

                {uploadState === "uploading" && (
                    <>
                        <label htmlFor="fileUpload" className="upload-document-lable">
                            <span className="upload-document-icon-blk">
                                <Spinner animation="border" size="1.8rem" className="" />
                            </span>
                            <div className="upload-document-lable-text">
                                <h6 className="ud-lable-text exado_body_text">
                                    {uploadingTxt.udHeading}
                                </h6>
                            </div>
                            <PiTrash size="1.8rem" />
                        </label>
                    </>
                )}

                {uploadState === "uploaded" && (
                    <>
                        <label htmlFor="fileUpload" className="upload-document-lable">
                            <span className="upload-document-icon-blk">
                                <PiCheck size={18} />
                            </span>
                            <div className="upload-document-lable-text">
                                <h6 className="ud-lable-text exado_body_text">
                                    {uploadedTxt.udHeading}
                                </h6>
                                <span className="ud-lable-text-span exado_body_text">
                                    {uploadedTxt.udSubHeading}
                                </span>
                            </div>
                            <PiTrash size="1.8rem" />
                        </label>
                    </>
                )}

                {uploadState === "error" && (
                    <>
                        <label htmlFor="fileUpload" className="upload-document-lable">
                            <span className="upload-document-icon-blk">
                                <RxCross1 size={18} />
                            </span>
                            <div className="upload-document-lable-text">
                                <h6 className="ud-lable-text exado_body_text">
                                    {errorTxt.udHeading}
                                </h6>
                                <span className="ud-lable-text-span exado_body_text">
                                    {errorMessage}
                                </span>
                            </div>
                            <PiTrash size="1.8rem" />
                        </label>
                    </>
                )}
            </div>
        </div>
    );
};

export default DocumentUpload;
